import { render, staticRenderFns } from "./QuestionItemBank.vue?vue&type=template&id=c9770a32&scoped=true"
import script from "./QuestionItemBank.vue?vue&type=script&lang=js"
export * from "./QuestionItemBank.vue?vue&type=script&lang=js"
import style0 from "./QuestionItemBank.vue?vue&type=style&index=0&id=c9770a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9770a32",
  null
  
)

export default component.exports